<script>
export default {
  name: 'IconEyeClose',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
  computed: {
    // ID único por instância (this._uid é garantido único por componente Vue) —
    // o id fixo original colide quando o ícone renderiza mais de uma vez na página.
    maskId() {
      return `mask0_3736_51110_${this._uid}`
    },
  },
}
</script>

<template
  ><svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Modelo=Icon, Property 2=Fill, Property 3=eye-off">
      <path
        id="Mask"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.4072 17.993L20.7073 19.293C21.0983 19.684 21.0983 20.316 20.7073 20.707C20.5123 20.902 20.2563 21 20.0002 21C19.7442 21 19.4882 20.902 19.2932 20.707L16.5863 18L16.0002 17.414L14.6552 16.069L14.5863 16L12.0839 13.4977C12.0561 13.4992 12.0282 13.5 12 13.5C11.173 13.5 10.5 12.827 10.5 12C10.5 11.9718 10.5008 11.9439 10.5023 11.9161L7.28325 8.69701L5.53225 6.94601L3.29325 4.70701C2.90225 4.31601 2.90225 3.68401 3.29325 3.29301C3.68425 2.90201 4.31625 2.90201 4.70725 3.29301L6.42025 5.00601L7.88525 6.47101L11.9165 10.5023C11.9442 10.5008 11.972 10.5 12 10.5C12.827 10.5 13.5 11.173 13.5 12C13.5 12.028 13.4992 12.0558 13.4977 12.0835L17.4143 16L19.4072 17.993ZM8.5928 5.76421L11.3898 8.56121C11.5888 8.52621 11.7908 8.50021 11.9998 8.50021C13.9298 8.50021 15.4998 10.0702 15.4998 12.0002C15.4998 12.2092 15.4738 12.4112 15.4388 12.6102L18.1208 15.2932L18.9548 16.1272C20.4768 14.7392 21.4528 13.2202 21.8678 12.4972C22.0438 12.1892 22.0438 11.8102 21.8678 11.5022C21.2298 10.3902 17.7058 4.81621 11.7298 5.00321C10.5458 5.03421 9.4738 5.28921 8.5018 5.67421L8.5928 5.76421ZM13.948 16.7771L15.293 18.1211L15.498 18.3261C14.526 18.7111 13.455 18.9661 12.271 18.9961C12.189 18.9991 12.106 19.0001 12.025 19.0001C6.162 19.0001 2.762 13.5951 2.132 12.4971C1.956 12.1891 1.956 11.8101 2.132 11.5021C2.547 10.7801 3.523 9.26111 5.045 7.87311L6.576 9.40511L8.562 11.3901C8.526 11.5891 8.5 11.7911 8.5 12.0001C8.5 13.9301 10.07 15.5001 12 15.5001C12.209 15.5001 12.411 15.4741 12.61 15.4381L13.879 16.7071L13.948 16.7771Z"
        :fill="color"
      />
      <mask
        :id="maskId"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="20"
        height="19"
      >
        <path
          id="Mask_2"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.4072 17.993L20.7073 19.293C21.0983 19.684 21.0983 20.316 20.7073 20.707C20.5123 20.902 20.2563 21 20.0002 21C19.7442 21 19.4882 20.902 19.2932 20.707L16.5863 18L16.0002 17.414L14.6552 16.069L14.5863 16L12.0839 13.4977C12.0561 13.4992 12.0282 13.5 12 13.5C11.173 13.5 10.5 12.827 10.5 12C10.5 11.9718 10.5008 11.9439 10.5023 11.9161L7.28325 8.69701L5.53225 6.94601L3.29325 4.70701C2.90225 4.31601 2.90225 3.68401 3.29325 3.29301C3.68425 2.90201 4.31625 2.90201 4.70725 3.29301L6.42025 5.00601L7.88525 6.47101L11.9165 10.5023C11.9442 10.5008 11.972 10.5 12 10.5C12.827 10.5 13.5 11.173 13.5 12C13.5 12.028 13.4992 12.0558 13.4977 12.0835L17.4143 16L19.4072 17.993ZM8.5928 5.76421L11.3898 8.56121C11.5888 8.52621 11.7908 8.50021 11.9998 8.50021C13.9298 8.50021 15.4998 10.0702 15.4998 12.0002C15.4998 12.2092 15.4738 12.4112 15.4388 12.6102L18.1208 15.2932L18.9548 16.1272C20.4768 14.7392 21.4528 13.2202 21.8678 12.4972C22.0438 12.1892 22.0438 11.8102 21.8678 11.5022C21.2298 10.3902 17.7058 4.81621 11.7298 5.00321C10.5458 5.03421 9.4738 5.28921 8.5018 5.67421L8.5928 5.76421ZM13.948 16.7771L15.293 18.1211L15.498 18.3261C14.526 18.7111 13.455 18.9661 12.271 18.9961C12.189 18.9991 12.106 19.0001 12.025 19.0001C6.162 19.0001 2.762 13.5951 2.132 12.4971C1.956 12.1891 1.956 11.8101 2.132 11.5021C2.547 10.7801 3.523 9.26111 5.045 7.87311L6.576 9.40511L8.562 11.3901C8.526 11.5891 8.5 11.7911 8.5 12.0001C8.5 13.9301 10.07 15.5001 12 15.5001C12.209 15.5001 12.411 15.4741 12.61 15.4381L13.879 16.7071L13.948 16.7771Z"
          fill="white"
        />
      </mask>
      <g :mask="`url(#${maskId})`">
        <g id="🎨 Color">
          <rect id="Base" width="24" height="24" :fill="color" />
        </g>
      </g>
    </g>
  </svg>
</template>
